const mixin = {
    methods: {
        toColor(colorTxt) {
            if (colorTxt === 'Green')
                return 'green'
            if (colorTxt === 'Silver')
                return 'silver'
            if (colorTxt === 'Yellow')
                return 'yellow'
            if (colorTxt === 'Space Gray')
                return '#a5adb0'
            else
                return colorTxt.toLowerCase()
        },
        // phoneColorSet(color, item) {
        //     const element = item.target;
        //     console.log(color.color);
        //     console.log(element);
        // },
        hexToRGB(hex, isPct) {
            let r = 0, g = 0, b = 0;
            isPct = isPct === true;


            // 3 digits
            if (hex.length == 4) {
                r = "0x" + hex[1] + hex[1];
                g = "0x" + hex[2] + hex[2];
                b = "0x" + hex[3] + hex[3];

                // 6 digits
            } else if (hex.length == 7) {
                r = "0x" + hex[1] + hex[2];
                g = "0x" + hex[3] + hex[4];
                b = "0x" + hex[5] + hex[6];
            }
            if (isPct) {
                r = +(r / 255 * 100).toFixed(1);
                g = +(g / 255 * 100).toFixed(1);
                b = +(b / 255 * 100).toFixed(1);
            }
            console.log(r);
            console.log(g);
            console.log(b);
            // console.log(rgb);
            return { r: r, g: g, b: b };
        }

    }
}

export default mixin